export const libraryConstants = {
    GETALL_REQUEST: 'LIBRARY_GETALL_REQUEST',
    GETALL_SUCCESS: 'LIBRARY_GETALL_SUCCESS',
    GETALL_FAILURE: 'LIBRARY_GETALL_FAILURE',

    GETBYUSERROLE_REQUEST: 'LIBRARY_GETBYUSERROLE_REQUEST',
    GETBYUSERROLE_SUCCESS: 'LIBRARY_GETBYUSERROLE_SUCCESS',
    GETBYUSERROLE_FAILURE: 'LIBRARY_GETBYUSERROLE_FAILURE' 
};



// WEBPACK FOOTER //
// ./src/_constants/library.constants.js